<script>
	import { t } from '$lib/translations'
	import { Anchor, Separator } from '.'

	export let faqs = []
	export let hideHeader = false
</script>

<div class="gray background-full">
	<Anchor id="faq" />
	<section class="FAQ-cont py-12 md:px-4" class:pt-0={hideHeader}>
		{#if !hideHeader}
			<Separator />
			<h2 class="text-center font-extrabold">{t('faq.title')}</h2>
			<p class="mb-6 text-center">
				{@html t('faq.subtitle')}
			</p>
		{/if}
		{#each faqs as faq}
			<div
				class="FAQ-item {faq.open ? 'active' : ''} rounded-xl border border-neutral-200"
				role="presentation"
				on:click={() => (faq.open = !faq.open)}
			>
				<h4 class="unstyled text-2xl-res md:text-xl">{faq.question}</h4>
				<p class="text-lg-res md:text-base">{@html faq.answer}</p>
			</div>
		{/each}
	</section>
</div>

<style lang="scss">
	.FAQ-cont {
		max-width: 950px;
		margin: 0 auto;

		:global(a) {
			color: #e20613;
		}

		.FAQ-item {
			background: #fff;
			padding: 30px 65px 30px 30px;
			cursor: pointer;
			margin: 10px 0;
			// box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);

			h4 {
				margin: 0;
				position: relative;

				&::before {
					content: '';
					position: absolute;
					right: -30px;
					width: 20px;
					height: 20px;
					top: 50%;
					transform: translateY(-50%);
					border-radius: 999px;
				}

				&::after {
					content: url('/images/icons/arrow-down-black.svg');
					position: absolute;
					right: -40px;
					width: 30px;
					align-items: center;
					justify-content: center;
					display: flex;
					height: 30px;
					top: 50%;
					transform: translateY(calc(-50%));

					@media only screen and (max-width: 760px) {
						transform: translateY(calc(-50%));
					}
				}
			}

			p {
				height: 0;
				overflow: hidden;
				margin-bottom: 0;
				margin-top: 0;
			}

			@media (hover: hover) {
				&:hover::before {
					background: #e20613;
				}
			}

			&.active {
				h4::after {
					transform: rotate(180deg) translateY(calc(50%));

					@media only screen and (max-width: 760px) {
						transform: rotate(180deg) translateY(calc(50%));
					}
				}

				p {
					height: auto;
					padding-top: 15px;
				}
			}
		}
	}
</style>
